module.exports = __webpack_public_path__ + "static/media/8.335eb012.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shirts/8.png
// module id = 1046
// module chunks = 0